import { TeamChatbotState } from '../types/teamChatbot'

export const initialTeamChatbotState: TeamChatbotState = {
  teamChatbots: [],
  isLoading: false,
  error: null,
}
